import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { GestionPrecioMasivoAll } from './components/GestionPrecioMasivoAll';

export default function GestionPrecioMasivo() {
    return (
        <MainContent
            component={<GestionPrecioMasivoAll />}
            titulo='Cambios de precios masivos'
            noBackground
            tableMaxWidth
        />
    );

};
